module.exports = __webpack_public_path__ + "static/media/TravelCardLogo.2c10c7ef.png";